import { Skeleton } from "antd";

import { BdsSection } from "@buildertrend/components";

export const AccountingLinkingCardSkeleton: React.FunctionComponent = () => {
    return (
        <BdsSection testid="accountingLinkingCard" className="AccountingLinkingCard">
            <div className="flex flex-row">
                <div className="flex flex-col grow">
                    <Skeleton.Image style={{ width: 160, height: 40 }} />
                </div>
                <div className="flex flex-col">
                    <Skeleton.Button style={{ width: 80, height: 24 }} active />
                </div>
            </div>
            <div style={{ marginTop: "16px" }}>
                <Skeleton paragraph={{ rows: 3 }} active />
            </div>
        </BdsSection>
    );
};
